<!--
 * @描述: 电子名片直销员头部介绍
 * @作者: Phil.Yu
 * @时间: 2021年04月02日
-->
<template>
  <div>
    <div class="headerCardBg">
      <div class="a_position_a flex a_flex_a" style="width:60%;height:100%;padding:16px 0 16px 16px;border-radius: 5px;">
        <img :src="callingcard.avatar" alt="" style="width:100%;height:95%;border-radius: 5px;">
      </div>
      <div class="a_position_a right" style="width:100%;height:100%">
        <img src="@/assets/electronicCard/right.png" alt="" style="width:100%;height:100%">
        <div class="a_position_a" style="right: 6%;top:47px;width:48%;">
          <div class="name">{{callingcard.name}}</div>
          <div class="company">A.O.史密斯公司-高级服务顾问</div>
          <div class="flex" style="margin-top:27px">
            <div class="lable introduction" style="flex:1;">{{callingcard.introduction || "专注于家电领域，为客户提供专业的装修建议和售后保障"}}</div>
            <div>
              <img src="@/assets/electronicCard/bookmark.png" alt="" class="image">
            </div>
          </div>
          <div class="flex" style="margin-top:16px" v-if="callingcard.storeAddress" @click="link">
            <div class="lable" style="flex:1;text-decoration:underline;">
              {{callingcard.storeAddress}}
              <span v-if="locationNumber">
                所在门店 距您{{locationNumber}}
              </span>
            </div>
            <div>
              <img src="@/assets/electronicCard/pin.png" alt=""  class="image">
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name:"HeaderCard",
  props: {
    callingcard:{
      type: Object,
      default: function () {
        return {};
      },
    },
    shareId:{
      type: String,
      default:""
    },
    locationNumber:{
      type: String,
      default:""
    }
  },
  data() {
    return {
      location:null,
    };
  },
  methods: {
    //地理位置
    async link(){
      let that=this;
      if(that.callingcard.storeLocation){
        let location = this.callingcard.storeLocation.split(',')
        this.$store.dispatch('wxLogin/getLogSave', {targetId:"",shareId:this.shareId,targetType:"STORE"})
        window.wx.openLocation({
              latitude: Number(location[0]), // 纬度，浮点数，范围为90 ~ -90
              longitude: Number(location[1]), // 经度，浮点数，范围为180 ~ -180。
              name: that.callingcard.storeAddress, // 位置名
              address:'所在门店 距您'+that.locationNumber, // 地址详情说明
              scale: 16, // 地图缩放级别,整型值,范围从1~28。默认为最大
              infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
        });
      }else{
        that.copyText(that.callingcard.storeAddress)
      }   
    },
    copyText(node) {
      if (!node) {
        return;
      }
      var result;
      // 将复制内容添加到临时textarea元素中
      var tempTextarea = document.createElement("textarea");
      document.body.appendChild(tempTextarea);
      if (typeof node == "object") {
        // 复制节点中内容
        // 是否表单
        if (node.value) {
          tempTextarea.value = node.value;
        } else {
          tempTextarea.value = node.innerHTML;
        }
      } else {
        // 直接复制文本
        tempTextarea.value = node;
      }
      // 判断设备
      var u = navigator.userAgent;
      if (u.match(/(iPhone|iPod|iPad);?/i)) {
        // iOS
        // 移除已选择的元素
        window.getSelection().removeAllRanges();
        // 创建一个Range对象
        var range = document.createRange();
        // 选中
        range.selectNode(tempTextarea);
        // 执行选中元素
        window.getSelection().addRange(range);
        // 复制
        result = document.execCommand("copy");
        // 移除选中元素
        window.getSelection().removeAllRanges();
      } else {
        // 选中
        tempTextarea.select();
        // 复制
        result = document.execCommand("Copy");
      }
      // 移除临时文本域
      document.body.removeChild(tempTextarea);
      if (result) {
        this.$Toast('地址复制成功！')
      } else {
        this.$Toast('复制失败')
      }
    },
      

  },
};
</script>
<style lang="less" scoped>
.headerCardBg {
  width: 100%;
  height:100%;
  .name{
    font-weight: 500;
    font-size: 22px;
    line-height: 28px;
    color: #323233;
    width: 100%;
    text-align: right;
    padding-right:15px;
  }
  .lable{
    font-size: 12px;
    line-height: 16px;
    text-align: right;
    color: #4A4A4A;
    margin-right: 4px;
  }
  .image{
    width: 16px;
    height:16px

  }
  .introduction{
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .company{
    font-size:10px;
    line-height:14px;
    color:#1A4582;
    text-align: right;
    padding-right:15px;
    margin-top:2px;
  }

}
</style>